<p-tabView (onChange)="onTabChange($event)">
    <p-tabPanel header="Overview">
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12 p-md-4">
                <div class="p-fluid">
                    <div class="card" style="min-height: 160px;">
                        <h6 class="p-mb-0">Vendor Information</h6>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_billaddress  && poTemplate.labels_billaddress[0]?.isChecked">
                            {{rpoDetail?.vendorBusinessName}}</p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_billaddress  && poTemplate.labels_billaddress[1]?.isChecked">
                            {{rpoDetail?.purchaseOrder?.billingAddress?.streetAddress1}}<span
                                *ngIf="rpoDetail?.purchaseOrder?.billingAddress?.streetAddress1 !== ''">,</span>
                        </p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_billaddress  && poTemplate.labels_billaddress[1]?.isChecked">
                            {{rpoDetail?.purchaseOrder?.billingAddress?.streetAddress2}}<span
                                *ngIf="rpoDetail?.purchaseOrder?.billingAddress?.streetAddress2 !== ''">,</span>
                        </p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_billaddress  && poTemplate.labels_billaddress[2]?.isChecked">
                            {{rpoDetail?.purchaseOrder?.billingAddress?.city?.name}}<span
                                *ngIf="rpoDetail?.purchaseOrder?.billingAddress?.city?.name !== ''">, </span>
                            {{rpoDetail?.purchaseOrder?.billingAddress?.state?.name}}
                            <span *ngIf="rpoDetail?.purchaseOrder?.billingAddress?.state?.name !== ''">,
                            </span> {{rpoDetail?.purchaseOrder?.billingAddress?.country?.name}}
                            <span *ngIf="rpoDetail?.purchaseOrder?.billingAddress?.country?.name !== ''">,
                            </span> {{rpoDetail?.purchaseOrder?.billingAddress?.zipCode}}
                        </p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_billaddress  && poTemplate.labels_billaddress[3]?.isChecked">
                            {{rpoDetail?.purchaseOrder?.contact?.firstName}}
                            {{rpoDetail?.purchaseOrder?.contact?.lastName}}</p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_billaddress  && poTemplate.labels_billaddress[4]?.isChecked">
                            {{rpoDetail?.purchaseOrder?.contact?.contactPhones[0]?.phone?.number}}</p>
                    </div>
                </div>
            </div>
            <div class="p-col-12 p-md-4">
                <div class="p-fluid">
                    <div class="card" style="min-height: 160px;">
                        <h6 class="p-mb-0">Shipping
                        </h6>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_shipaddress  && poTemplate.labels_shipaddress[0]?.isChecked">
                            {{app?.user?.organizationName}}</p>
                        <p class="p-mb-0">
                            {{rpoDetail?.warehouse?.name}}-{{rpoDetail?.warehouse?.locationId}}</p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_shipaddress  && poTemplate.labels_shipaddress[1]?.isChecked">
                            {{rpoDetail?.warehouse?.address?.streetAddress1}}<span
                                *ngIf="rpoDetail?.warehouse?.address?.streetAddress1 !== ''">,</span>
                        </p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_shipaddress  && poTemplate.labels_shipaddress[1]?.isChecked">
                            {{rpoDetail?.warehouse?.address?.streetAddress2}}<span
                                *ngIf="rpoDetail?.warehouse?.address?.streetAddress2 !== ''">,</span>
                        </p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_shipaddress  && poTemplate.labels_shipaddress[2]?.isChecked">
                            {{rpoDetail?.warehouse?.address?.city?.name}}<span
                                *ngIf="rpoDetail?.warehouse?.address?.city?.name !== ''">, </span>
                            {{rpoDetail?.warehouse?.address?.state?.name}}
                            <span *ngIf="rpoDetail?.warehouse?.address?.state?.name !== ''">, </span>
                            {{rpoDetail?.warehouse?.address?.country?.name}}
                            <span *ngIf="rpoDetail?.warehouse?.address?.country?.name !== ''">, </span>
                            {{rpoDetail?.warehouse?.address?.zipCode}}
                        </p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_shipaddress  && poTemplate.labels_shipaddress[3]?.isChecked">
                            {{app?.user?.userName}}</p>
                    </div>
                </div>
            </div>
            <div class="p-col-12 p-md-4">
                <div class="p-fluid">
                    <div class="card" style="min-height: 160px;">
                        <p class="p-mb-0" *ngIf="poTemplate && poTemplate.labels_misc &&
                    poTemplate.labels_misc[0]?.isChecked">
                            {{poTemplate && poTemplate.labels_misc &&
                            poTemplate.labels_misc[0]?.labelname}}:
                            {{rpoDetail?.createdDate | date: 'MM/dd/yyyy'}}
                        </p>
                        <p class="p-mb-0" *ngIf="isAllowPostingPeriod">
                            <span>Posting Period:{{  rpoDetail?.postingDate ? (rpoDetail?.postingDate  | date: 'MMMM yyyy' )  : null }}</span>
                        </p>
                        <p class="p-mb-0" *ngIf="poTemplate && poTemplate.labels_misc &&
                    poTemplate.labels_misc[1]?.isChecked">
                            {{poTemplate && poTemplate.labels_misc &&
                            poTemplate.labels_misc[1]?.labelname}}.:
                            {{rpoDetail?.number}}
                        </p>
                        <p class="p-mb-0" *ngIf="poTemplate && poTemplate.labels_misc &&
                    poTemplate.labels_misc[2]?.isChecked">{{poTemplate &&
                            poTemplate.labels_misc &&
                            poTemplate.labels_misc[2]?.labelname}}: {{rpoDetail?.rpoStatus}}</p>
                        <p class="p-mb-0" *ngIf="poTemplate && poTemplate.labels_misc &&
                    poTemplate.labels_misc[3]?.isChecked">{{poTemplate &&
                            poTemplate.labels_misc &&
                            poTemplate.labels_misc[3]?.labelname}}: {{rpoDetail?.createdByUser}}</p>
                        <p class="p-mb-0" *ngIf="poTemplate && poTemplate.labels_misc &&
                    poTemplate.labels_misc[4]?.isChecked">{{poTemplate &&
                            poTemplate.labels_misc &&
                            poTemplate.labels_misc[4]?.labelname}}.: {{rpoDetail?.referenceNo}}</p>
                        <p class="p-mb-0" *ngIf="rpoDetail && (baseCurrency?.currencyId!==rpoDetail?.currencyUnitId)">
                            Currency: 1 {{baseCurrency?.code}} = {{rpoDetail?.exchangeRate}}
                            {{rpoDetail?.currencyUnit?.code}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-field p-formgrid p-grid" *ngIf="poTemplate?.labels_section?.length>0">
            <div class="p-col" *ngIf="poTemplate.labels_section[0]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">{{poTemplate.labels_section[0]?.labelname}}</h6>
                    <p class="p-mb-0">
                        {{rpoDetail?.paymentTerm?.name}}
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="poTemplate.labels_section[1]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">{{poTemplate.labels_section[1]?.labelname}}</h6>
                    <p class="p-mb-0">
                        {{rpoDetail?.paymentMethod?.name}}
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="poTemplate.labels_section[2]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">{{poTemplate.labels_section[2]?.labelname}}</h6>
                    <p class="p-mb-0">
                        {{rpoDetail?.shippingTerm?.name}}
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="poTemplate.labels_section[3]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">{{poTemplate.labels_section[3]?.labelname}}</h6>
                    <p class="p-mb-0">
                        {{rpoDetail?.shippingMethod?.name}}
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="poTemplate.labels_section[4]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">{{poTemplate.labels_section[4]?.labelname}}</h6>
                    <p class="p-mb-0">
                        {{rpoDetail?.user?.firstName}} {{rpoDetail?.user?.lastName}}
                    </p>
                </div>
            </div>
        </div>
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12">
                <p-table [value]="receivePurchaseListTB" styleClass="p-datatable-gridlines p-datatable-striped">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{poTemplate && poTemplate.labels_table && poTemplate.labels_table[0]?.labelname}}
                            </th>
                            <th>{{poTemplate && poTemplate.labels_table && poTemplate.labels_table[1]?.labelname}}
                            </th>
                            <th style="width: 400px;">{{poTemplate && poTemplate.labels_table &&
                                poTemplate.labels_table[2]?.labelname}}
                            </th>
                            <th>{{poTemplate && poTemplate.labels_table && poTemplate.labels_table[3]?.labelname}}
                            </th>
                            <th>{{poTemplate && poTemplate.labels_table && poTemplate.labels_table[4]?.labelname}}
                            </th>
                            <th>{{poTemplate && poTemplate.labels_table && poTemplate.labels_table[5]?.labelname}}
                            </th>
                            <th>{{poTemplate && poTemplate.labels_table && poTemplate.labels_table[6]?.labelname}}
                            </th>
                            <th>{{poTemplate && poTemplate.labels_table && poTemplate.labels_table[7]?.labelname}}
                            </th>
                            <th *ngIf="poTemplate?.labels_table[10]?.isChecked">
                                {{poTemplate && poTemplate.labels_table &&
                                poTemplate.labels_table[10]?.labelname}}
                            </th>
                            <th *ngIf="poTemplate?.labels_table[9]?.isChecked">
                                {{poTemplate && poTemplate.labels_table &&
                                poTemplate.labels_table[9]?.labelname}}
                            </th>
                            <th>{{poTemplate && poTemplate.labels_table && poTemplate.labels_table[8]?.labelname}}
                            </th>
                            <th>Serial No.</th>
                            <th class="p-text-center">
                                <ng-container style="width: 3rem">
                                    <span class="p-mr-2">CLS</span>
                                </ng-container>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product>
                        <ng-container>
                            <tr>
                                <td>{{product.poNo}}</td>
                                <td>{{product.itemNo}}</td>
                                <td>{{product.description | shorten: 55}}</td>
                                <td><span *ngIf="product.typeId!=4">{{product.uom}}</span></td>
                                <td>
                                    <span *ngIf="product.typeId!=4">{{rpoDetail?.currencyUnit?.symbol}}
                                        {{product.pricePerProduct | customNumberFormat: length }}</span>
                                </td>
                                <td>{{product.quantity | customNumberFormat: qtyDecimal}}</td>
                                <td>{{product.quantityPending | customNumberFormat: qtyDecimal}}</td>
                                <td><span *ngIf="product.typeId!=4">{{product.quantityReceived | customNumberFormat:
                                        qtyDecimal}}</span></td>
                                <td>{{rpoDetail?.currencyUnit?.symbol}} {{product.cost | customNumberFormat: length }}
                                </td>
                                <td *ngIf="poTemplate?.labels_table[9]?.isChecked">
                                    {{rpoDetail?.currencyUnit?.symbol}} {{product.taxAmount | customNumberFormat: length
                                    }}</td>
                                <td>{{rpoDetail?.currencyUnit?.symbol}} {{product.netAmount | customNumberFormat: length
                                    }}</td>
                                <td>
                                    <span class="btnBars p-mt-2 badge"
                                        *ngIf="product.typeId!=4 && product.trackingEnabled"
                                        (click)="openScanInfo(product,'product')">
                                        <i class="pi pi-th-large" pBadge value="{{product?.serialCount}}"
                                            severity="warning"></i>
                                    </span>
                                </td>
                                <td>
                                    <ng-container *ngIf="product.typeId!=4">
                                        <p-checkbox binary="true" [disabled]="true"
                                            [(ngModel)]="product.isClosed"></p-checkbox>
                                        {{product.receivedProductStatus}}
                                    </ng-container>
                                </td>
                            </tr>
                            <!-- bundle items -->
                            <tr *ngFor="let bundle of product.products;let i = index" class="bundleRow">
                                <td></td>
                                <td>
                                    {{bundle.itemNo ? bundle.itemNo : null}}
                                </td>
                                <td>
                                    {{bundle.description?.length > 55 ? (bundle.description | slice: 0:55) + "...":
                                    bundle.description}}
                                </td>
                                <td>
                                    {{bundle.uom }}
                                </td>
                                <td>
                                    {{bundle.pricePerProduct | customNumberFormat: length | currencySymbol}}
                                </td>
                                <td>
                                    {{bundle.quantity}}
                                </td>
                                <td>{{bundle.quantityPending}}</td>
                                <td>
                                    {{bundle.quantityReceived}}
                                </td>
                                <td>
                                    {{bundle.cost | customNumberFormat: length | currencySymbol}}
                                </td>
                                <td>
                                    <span class="btnBars p-mt-2 badge" *ngIf="bundle.trackingEnabled"
                                        (click)="openScanInfo(bundle,'bundle')">
                                        <i class="pi pi-th-large" pBadge value="{{bundle?.serialCount}}"
                                            severity="warning"></i>
                                    </span>
                                </td>
                                <td>
                                    <p-checkbox binary="true" [disabled]="true"
                                        [(ngModel)]="bundle.isClosed"></p-checkbox>
                                    {{bundle.receivedProductStatus}}
                                </td>
                            </tr>
                        </ng-container>
                    </ng-template>
                    <ng-template pTemplate="footer">
                        <tr>
                            <td></td>
                            <td>Total</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td *ngIf="poTemplate?.labels_table[10]?.isChecked">{{rpoDetail?.currencyUnit?.symbol}} {{subTotal | customNumberFormat: length }}</td>
                            <td *ngIf="poTemplate?.labels_table[9]?.isChecked">
                              {{rpoDetail?.currencyUnit?.symbol}} {{tax | customNumberFormat: length }}
                            </td>
                            <td>{{rpoDetail?.currencyUnit?.symbol}} {{lineTotal | customNumberFormat: length }}</td>
                            <td></td>
                            <td></td>
                          </tr>
                        <tr *ngIf="poTemplate && poTemplate.labels_footer  && poTemplate.labels_footer[1]?.isChecked">
                            <td [attr.colspan]="(poTemplate?.labels_table[9]?.isChecked ? 10 : 9)" class="p-text-right">{{poTemplate && poTemplate.labels_footer &&
                                poTemplate.labels_footer[1]?.labelname}}
                            </td>
                            <td colspan="3">
                                <span>{{rpoDetail?.currencyUnit?.symbol}} {{shippingAmount | customNumberFormat: length
                                    }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td [attr.colspan]="(poTemplate?.labels_table[9]?.isChecked ? 10 : 9)" class="action">
                                <div class="p-d-flex" style="flex-direction: row-reverse;">
                                    <span class="p-mr-3 p-pt-1">
                                        {{poTemplate && poTemplate.labels_footer &&
                                        poTemplate.labels_footer[2]?.labelname}}
                                    </span>
                                </div>
                            </td>
                            <td colspan="3">{{rpoDetail?.currencyUnit?.symbol}} {{ discount | customNumberFormat: length
                                }}</td>
                        </tr>
                        <tr>
                            <td [attr.colspan]="(poTemplate?.labels_table[9]?.isChecked ? 10 : 9)" class="action">
                                <div class="p-d-flex" style="flex-direction: row-reverse;">
                                    <span class="p-mr-3 p-pt-1">
                                        {{poTemplate && poTemplate.labels_footer &&
                                        poTemplate.labels_footer[4]?.labelname}}
                                    </span>
                                </div>
                            </td>
                            <td colspan="3">{{rpoDetail?.currencyUnit?.symbol}} {{ tax | customNumberFormat: length
                                }}</td>
                        </tr>
                        <tr>
                            <td [attr.colspan]="(poTemplate?.labels_table[9]?.isChecked ? 10 : 9)" class="p-text-right"> {{poTemplate && poTemplate.labels_footer &&
                                poTemplate.labels_footer[3]?.labelname}}
                            </td>
                            <td colspan="3">{{rpoDetail?.currencyUnit?.symbol}} {{orderTotal | customNumberFormat:
                                length }}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12"
                *ngIf="poTemplate && poTemplate.labels_message  && poTemplate.labels_message[0]?.isChecked">
                <p>{{poTemplate && poTemplate.labels_message && poTemplate.labels_message[0]?.labelname}}: {{notes}}
                </p>
            </div>
        </div>

        @if(!isView){
        <app-edit-itemreceipt [selectedReceived]="rpoDetail" [selectedChannel]="selectedChannel"
            [baseCurrency]="baseCurrency" [orgCurrency]="orgCurrency" (loadList)="updateJournal($event)"
            (onClose)="closeJournal()"></app-edit-itemreceipt>
        }
    </p-tabPanel>
    <p-tabPanel header="Impacts on G/L">
        <app-inventory-impacts-gl [selectedId]="itemReceiptId" [objectTypeId]="transactionTypeIds.ItemReceipt"
            [callApi]="glApiCall"></app-inventory-impacts-gl>
    </p-tabPanel>
</p-tabView>